import { EVENT_IMPORTED_TYPE_MAP } from './eventImportedTypeMap';

export const EVENT_SOURCES = {
  ...EVENT_IMPORTED_TYPE_MAP,
  IDEALIST: 'Idealist',
};

export const EVENT_SOURCE_RADIO_OR_SELECT_OPTIONS = () =>
  Object.entries(EVENT_SOURCES)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key as keyof typeof EVENT_SOURCES,
      label: value,
    }));

export const EVENT_SOURCE_CHECKBOX_OPTIONS = () =>
  Object.entries(EVENT_SOURCES)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key as keyof typeof EVENT_SOURCES,
      label: value,
    }));
